import { Link } from 'react-router-dom'
import { useHelpContent, useLocale } from '@autoplan/web-sanity'
import { AccordionPanel, Breadcrumb, Heading, Stack } from '@autoplan/web-ui'
import { FaqAnswer } from '../components/FaqAnswer'
import { ContactInfoCard } from '../components/Cards/ContactInfoCard'
import { ContactForm } from '../components/ContactForm'

export const Help = () => {
  const content = useHelpContent()
  const { t } = useLocale()

  const faq = content?.faq ?? []

  return (
    <Stack spacing="3xl">
      <Breadcrumb
        items={[
          { path: '/', label: t('home.breadcrumb.home') },
          { path: '/help', label: t('home.breadcrumb.help') },
        ]}
        linkAs={Link}
      />
      <Stack spacing="xl">
        {faq.length > 0 && <Heading size="lg">{t('home.help.faqTitle')}</Heading>}
        <div className="ap:grid ap:grid-cols-1 ap:gap-2xl ap:xl:grid-cols-2 ap:xl:items-start ap:xl:gap-2xl">
          {faq.length > 0 && (
            <AccordionPanel type="single" collapsible>
              {faq.map((item) => (
                <AccordionPanel.Item key={item._id} value={item._id} title={item.question}>
                  <FaqAnswer answer={item.answer} />
                </AccordionPanel.Item>
              ))}
            </AccordionPanel>
          )}
          <Stack spacing="2xl">
            {content?.contact && <ContactInfoCard contact={content.contact} />}
            <ContactForm />
          </Stack>
        </div>
      </Stack>
    </Stack>
  )
}
